<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemBeneficiaire.nom+' '+itemBeneficiaire.prenom}}
    </h4>

    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="modal-body" [ngBusy]="{
      busy: busyGet,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <ng-container>
        <div class="row">
            <form class="m-1" *ngIf="itemBeneficiaire">
                <div class="row">
                    <div class="col-md-10">
                        <div class="row">
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Filiale :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Filiale" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.filiale_libelle" name="filiale_libelle" autocomplete="off" type="text"
                                 />
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Garant :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Garant" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.garant_libelle" name="garant_libelle" autocomplete="off" type="text"
                                 />
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Police :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Police" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.police_libelle" name="police_libelle" autocomplete="off" type="text"
                                 />
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Collège :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Collège" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.college_libelle" name="college_libelle" autocomplete="off" type="text"
                                 />
                            </div>
                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule chez garant :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Matricule chez garant"
                                    autocomplete="off" [(ngModel)]="itemBeneficiaire.matricule_chez_garant"
                                    name="matricule_chez_garant" autocomplete="off" type="text" />
                            </div>

                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule chez souscripteur :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Matricule chez souscripteur"
                                    autocomplete="off" [(ngModel)]="itemBeneficiaire.matricule_chez_souscripteur"
                                    name="matricule_chez_souscripteur" autocomplete="off" type="text" />
                            </div>
                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Matricule assuré:
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Matricule assuré" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.matricule_assure" name="matricule_assure" autocomplete="off" type="text"
                                     />
                            </div>

                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Nom :
                                    <span class="required_champs">*</span>
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Nom" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.nom" name="nom" autocomplete="off" type="text" />
                            </div>

                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Prénoms :
                                    <span class="required_champs">*</span>
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Prénoms" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.prenom" name="prenom" autocomplete="off" type="text" />
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Civilité :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Civilité" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.civilite_libelle" name="civilite_libelle" autocomplete="off" type="text"
                                     />
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1">
                                <label>Date de naissance :
                                    <span class="required_champs">*</span>
                                </label>
                                <!-- <input disabled
                          onkeydown="return false" -->
                                <input disabled (bsValueChange)="getAge()" type="text" placeholder="Date de naissance"
                                    autocomplete="off" class="form-control" bsDatepicker [bsConfig]="{
                            dateInputFormat: 'DD/MM/YYYY',
                            containerClass: 'theme-dark-blue'
                          }" [(ngModel)]="itemBeneficiaire.date_naissance" name="date_naissance" />
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Genre :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Genre" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.genre_libelle" name="genre_libelle" autocomplete="off" type="text"
                                     />
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Statut :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Statut" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.statut_libelle" name="statut_libelle" autocomplete="off" type="text"
                                     />
                            </div>
                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Taille (cm) :
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Taille" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.taille" name="taille" autocomplete="off" type="text"
                                     />
                            </div>
                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Poids (kg) :
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Poids" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.poids" name="poids" autocomplete="off" type="text"
                                    mask="separator" />
                            </div>
                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Groupe sanguin :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Groupe sanguin" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.groupe_sanguin_libelle" name="groupe_sanguin_libelle" autocomplete="off"
                                    type="text" />
                            </div>

                            <!-- <div class="col-md-3" style="padding-left: 5px; padding-right: 5px">
        
                            <label>Matricule :
                            </label>
        
                            <input disabled disabled class="form-control custom-input" placeholder="Matricule" autocomplete="off"
                                [(ngModel)]="itemBeneficiaire.matricule" name="matricule" autocomplete="off"
                                type="text" />
                        </div> -->



                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Numéro CNAM :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Numéro CNAM" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.numero_cnam" name="numero_cnam" autocomplete="off"
                                    type="text" />
                            </div>

                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Nature pièce :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Nature pièce" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.nature_piece" name="nature_piece" autocomplete="off"
                                    type="text" />
                            </div>

                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Numéro pièce :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Numéro pièce" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.numero_piece" name="numero_piece" autocomplete="off"
                                    type="text" />
                            </div>




                            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1">
                                <label>Validité :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>
                                <input disabled type="text" placeholder="Validité" autocomplete="off" class="form-control"
                                    bsDatepicker [bsConfig]="{
                            
                            containerClass: 'theme-dark-blue'
                          }" [(ngModel)]="itemBeneficiaire.validite_piece" name="validite_piece" />
                            </div>


                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Email :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Email" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.email" name="email" autocomplete="off" type="email" />
                            </div>

                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Email 2 :
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Email2" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.email2" name="email2" autocomplete="off" type="email" />
                            </div>
                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">

                                <label>Téléphone :
                                    <!-- <span class="required_champs">*</span> -->
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Téléphone" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.telephone" name="telephone" autocomplete="off" type="text"
                                    mask="00-00-00-00-00" />
                            </div>
                            <div class="col-md-2" style="padding-left: 5px; padding-right: 5px">
                                <label>Téléphone 2 :
                                </label>

                                <input disabled class="form-control custom-input" placeholder="Téléphone 2" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.telephone2" name="telephone2" autocomplete="off" type="text"
                                    mask="00-00-00-00-00" />
                            </div>

                            <div style="position: relative;" class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-1 select-container">
                                <label>Avenant :
                                    <span class="required_champs">*</span>
                                </label>
                                <input disabled class="form-control custom-input" placeholder="Avenant" autocomplete="off"
                                    [(ngModel)]="itemBeneficiaire.avenant_libelle" name="avenant_libelle" autocomplete="off" type="email" />
                            </div>

                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1">
                                
                                <div class="row" style="padding: 0">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-1 mt-2">
                                        <img src="{{
                                            itemBeneficiaire.image_url ||
                                'assets/images/custom/user-ano.jpeg'
                            }}" style="
                              width: 100%;
                              height: 200px;

                              display: block;
                            " />
                                  
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <label for="img" style="
                            width: 100%;
                            background-color: #0465aa;
                            padding: 5px;
                            cursor:pointer
                          ">
                                            <span style="color: white; padding: 5px">Choisir une image</span>
                                        </label>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-md-12" style="text-align: center;">
                                    Age: <strong>{{getAge()}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <!-- <app-beneficiare-detail-prime
                        [matricule_assure]="itemBeneficiaire.matricule_assure"></app-beneficiare-detail-prime> -->
                </div>
            </form>

        </div>
    </ng-container>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">


        <button type="button" class="btn btn-md btn-cancel pull-right" (click)="bsModalRef.hide()">
            Fermer
        </button>
    </div>
</div>